/**
 * Inquiry API
 * ───────────
 * Uses the shared axios instance (src/api/axios.js), which attaches the
 * Bearer token when one exists. `create` is a public endpoint, so it works
 * fine for anonymous landing-page visitors (no token → no header).
 */

import api from './axios';

export const inquiryApi = {
  // Public — submit the "Get Early Access" form.
  create: (payload) => api.post('/inquiries', payload),

  // Admin — list (optional { status, search }) with status counts in meta.
  list: (params = {}) => api.get('/inquiries', { params }),

  // Admin — update status and/or notes.
  updateStatus: (id, payload) => api.patch(`/inquiries/${id}`, payload),

  // Admin — delete.
  remove: (id) => api.delete(`/inquiries/${id}`),
};

export default inquiryApi;